module.exports = __webpack_public_path__ + "img/logo.9d6948d5.png";